// extracted by mini-css-extract-plugin
module.exports = {"ClipPath":"TopSectionBgImage-module--ClipPath--XmRb4","bgImage":"TopSectionBgImage-module--bgImage--VHw85","bgImageCentered":"TopSectionBgImage-module--bgImageCentered--2s9s4"};